import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import DangerToast from '@/assets/smartcity/danger-toast.svg';
import InfoToast from '@/assets/smartcity/info-toast.svg';
import SuccessToast from '@/assets/smartcity/success-toast.svg';
import WarningToast from '@/assets/smartcity/warning-toast.svg';

// export type ToastType = 'success' | 'error' | 'warning' | 'info';

const config = {
  success: {
    color: '#22C55E',
    bg: '#F3F6FE',
    icon: SuccessToast,
  },
  error: {
    color: '#EF4444',
    bg: '#F3F6FE',
    icon: DangerToast,
  },
  warning: {
    color: '#F59E0B',
    bg: '#F3F6FE',
    icon: WarningToast,
  },
  info: {
    color: '#1677FF',
    bg: '#F3F6FE',
    icon: InfoToast,
  },
};

export type ToastType = keyof typeof config;

export interface CustomToastAction {
  label: string;
  onClick: () => void;
}

interface CustomToastProps {
  type: ToastType;
  title: string;
  message: string;
  // Optional buttons rendered below the message - each click is a genuine
  // user gesture, so it's the one reliable way to open a browser popup that
  // a synchronous window.open() couldn't (see AmbulanceDispatch.tsx).
  actions?: CustomToastAction[];
}

const CustomToast = ({ type, title, message, actions }: CustomToastProps) => {
  const item = config[type];

  return (
    <div
      style={{
        background: item.bg,
        borderLeft: `10px solid ${item.color}`,
      }}
      className="flex w-full items-center flex-row overflow-hidden gap-4 rounded-tr-[24px] rounded-br-[24px] p-5 shadow-lg"
    >
      <img src={item.icon} alt="icon" className="w-[50px] h-[50px]" />

      <div className="flex flex-col w-full gap-2">
        <span className="h5bold">{title}</span>
        <span className="title2 text-db-text-grey">{message}</span>
        {actions && actions.length > 0 && (
          <div className="flex flex-col gap-1">
            {actions.map((action) => (
              <button
                key={action.label}
                type="button"
                onClick={action.onClick}
                className="title2 text-left text-text-blue-100 underline"
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomToast;
